import { render, staticRenderFns } from "./Add_promotion_internet.vue?vue&type=template&id=4fa775f5&"
import script from "./Add_promotion_internet.vue?vue&type=script&lang=js&"
export * from "./Add_promotion_internet.vue?vue&type=script&lang=js&"
import style0 from "./Add_promotion_internet.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports